module.exports = __webpack_public_path__ + "static/r-wait.4b9b70e5.png";